import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { PARAMS } from 'src/app/_configs/params';
import { SharedService } from '../../_services/shared.service';
import { SigninWithOtpComponent } from 'src/app/modules/auth/_components/signin-with-otp/signin-with-otp.component';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { environment } from '../../../../../environments/environment';

import { StripMarginService } from 'src/app/modules/shared/_services/strip-margin.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,

})

export class HeaderComponent implements OnInit {
  imageBasePath: string = environment.TENDER.IMAGE_BASE_URL;
  baseUrl: string = environment.TENDER.BASE_URL;
  isHeaderNavActive: boolean = true;
  isStickyHeaderActive: boolean = false;
  isHumbergerActive: boolean = false;
  isVisibileHumburger: boolean = true;
  activeSection: string = "";
  currentUrl: any;
  showSearchBar: boolean = false;
  showSearchBarInListing: boolean = true;
  isLoggedIn: boolean = false;
  private userSubscription!: Subscription;
  signupmodal: boolean | undefined;

  userdetails: any;
  isWebView: boolean = false;
  shouldShowTrialBanner = false;
  daysLeft: number | null = null;

  private routerSubscription: Subscription | undefined;

  isBrowser: boolean;
  @ViewChild(SigninWithOtpComponent) modal!: SigninWithOtpComponent;

  @HostListener('window:scroll', ['$event']) onScroll(event: any) {
    if (this.sharedService.isBrowser) {
      let currentYPosition = window.pageYOffset;
      this.isStickyHeaderActive = currentYPosition > 20;
      this.showSearchBar = currentYPosition > 260;
    }
  }

  constructor(private router: Router,
    private scroll: ViewportScroller,
    private sharedService: SharedService,
    private authService: AuthService,
    private eRef: ElementRef,
    private stripMarginService: StripMarginService
  ) {
    this.isWebView = this.checkIfWebView();
    this.isBrowser = this.sharedService.isBrowser
    this.getRoute();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  ngOnInit(): void {
   
    this.userSubscription = this.authService.user$.subscribe(user => {
      this.isLoggedIn = !!user;
      this.userdetails = user?.userData || null;
      this.checkTrialBanner();
    });

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.onUrlChange();
      }
    });
    this.verifySearchBarShowHideCond();
  }

  async checkTrialBanner() {
    const { plan, daysLeft } = await this.authService.getPlanAndDaysLeft();
    const normalizedPlan = plan.toLowerCase();
  
    this.shouldShowTrialBanner =
      (normalizedPlan === 'advance' && daysLeft >= 0 && daysLeft <= 5) ||
      normalizedPlan === 'none';
  
    if (this.shouldShowTrialBanner) {
      this.daysLeft = daysLeft;
    }
  }

  navigateTo(path: string, event?: MouseEvent): void {
    if (event) {
      event.preventDefault(); // Prevent the default anchor behavior
    }
    this.router.navigate([path]); // Navigate using Angular's Router
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  isModalvis: boolean = false;
  openModalWithComponent() {
    this.isModalvis = true;
    // Delay setting the modal visibility to ensure view update
    setTimeout(() => {
      if (this.modal) {
        this.modal.isVisible = true; // Open the modal
      }
    }, 0);
  }

  navigate(link: any) {
    this.router.navigateByUrl('/' + link);
  }

  logout(): void {
    this.authService.logout();
  }

  onUrlChange() {
    this.verifySearchBarShowHideCond();
  }

  getRoute() {
    this.router.events.forEach((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.activeSection = "";
        this.searchBarShowHideCondition();
        this.hideHumbergerOnListingPageInMobile();
      }
    });
  }

  searchBarShowHideCondition() {
    this.isHeaderNavActive = this.currentUrl.split('?')[0] !== PARAMS.ROUTING_PATHS.TENDER_LIST;
  }

  hideHumbergerOnListingPageInMobile() {
    if (this.currentUrl.split('?')[0] === PARAMS.ROUTING_PATHS.TENDER_LIST) {
      if (this.sharedService.isBrowser) {
        this.isVisibileHumburger = !PARAMS.REGEX.DETECT_MOBILE_REGEX.test(window.navigator.userAgent);
      }
    } else {
      this.isVisibileHumburger = true;
    }
  }

  checkIfWebView(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes('wv') || userAgent.includes('webview')) {
      this.toggleStripHandler();
    }
    return userAgent.includes('wv') || userAgent.includes('webview');
  }

  onClickNavigation(selectedSection: string, event?: any) {
    this.activeSection = selectedSection;
    if (this.router.url === PARAMS.ROUTING_PATHS.HOME) {
      if (this.sharedService.isBrowser) {
        const elem = document.getElementById(selectedSection) as HTMLElement;
        const sectionPosition = (elem?.offsetTop || 0) - 70;
        this.scroll.scrollToPosition([sectionPosition, sectionPosition]);
      }
    }
    this.isHumbergerActive = false;
  }

  verifySearchBarShowHideCond() {
    this.showSearchBarInListing = this.sharedService.verifySearchBarShowHideCond();
  }
  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
  isStripVisible: boolean = true;
  toggleStripHandler() {
    this.isStripVisible = !this.isStripVisible;
    this.stripMarginService.toggleStripMargin();
  }
}
